export const authConfig = {
  storageTokenKeyName: "accessToken",
  usersname: "setUsersName",
  usersEmail: "usersEmail",
  appName: "Access Wealth Management Limited",
};
